<template>
  <div class="main-content">
    <div>
      <v-card class="pl-3 pr-3 fs-card-topbar" outlined shaped tile>
        <v-row class="mt-3 mb-n3" no-gutters>
          <v-col md="8">
            <v-form autocomplete="off">
              <v-row no-gutters>
                <v-text-field
                  @keydown.enter.prevent="pesquisar()"
                  style="border-top-left-radius: 15px; width: 325px; max-width: 325px"
                  class="fs-searchfield"
                  label="Pesquisar"
                  placeholder=" "
                  spellcheck="false"
                  v-model="textoPesquisa"
                  append-icon="mdi-magnify"
                  @click:append="pesquisar()"
                  outlined
                  dense
                />
                <v-btn
                  @click="dialogFiltros = true"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  outlined
                  small
                >
                  <v-icon class="mr-1">mdi-filter</v-icon>
                  Selecionar Filtros
                </v-btn>
                <v-btn v-if="filtroComposto.length > 0" @click="limparFiltros()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="error" outlined small>
                  <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>
                  Limpar Filtros
                </v-btn>
                <v-btn @click="exportarExcel()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="primary" outlined small>
                  <v-icon class="mr-1">mdi-file-excel</v-icon>
                  Exp. p/ Excel
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-spacer></v-spacer>
          <v-col md="4">
            <div class="pt-2 pl-1 mb-1 fs-topbar-crud">
              <v-btn @click="dialogUpload = true" class="mb-2 fs-btns-crud-grid" outlined small>
                <v-icon class="mr-1">mdi-plus-box</v-icon>
                Incluir Nova Arte
              </v-btn>
              <!-- <v-btn
                class="mb-2 fs-btns-crud-grid"
                outlined
                small
              >
                <v-icon class="mr-1">mdi-pen</v-icon>
                Editar
              </v-btn> -->
              <v-btn
                :disabled="!selecionados.length"
                @click="excluirArteFinal()"
                class="mb-2 fs-btns-crud-grid"
                color="red"
                outlined
                small
              >
                <v-icon class="ml-n1">mdi-close</v-icon>
                Excluir Artes
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog width="600px" v-model="dialogUpload" persistent>
        <v-card>
          <v-card-title>
            Incluir Nova Arte
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider class="mb-3"/>
          <v-card-text>
            <v-switch @change="limparFormUpload" v-model="capturaAutomaticaFTP" label="Capturar Dados Automaticamente (Artes FTP)"></v-switch>
            <v-form autocomplete="off">
              <v-row no-gutters>
                <v-col class="pr-1">
                  <v-text-field
                    label="Nome da Arte *"
                    v-model="novoEnvio.nome_arte"
                    @input="formatUppercase"
                    spellcheck="false"
                    placeholder=" "
                    class="mt-2"
                    hide-details
                    autofocus
                    outlined
                    dense
                  />
                </v-col>
                <v-col class="pl-1">
                  <v-text-field
                    label="Código do Cliente (ERP) *"
                    v-model="novaArte.cliente_id"
                    :disabled="capturaAutomaticaFTP"
                    append-icon="mdi-magnify"
                    @click:append="buscarDadosPeloCliente"
                    spellcheck="false"
                    placeholder=" "
                    class="mt-2"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="pr-1">
                  <v-text-field
                    label="Razão Social *"
                    v-model="novaArte.razao_social"
                    :disabled="capturaAutomaticaFTP"
                    @input="formatUppercase"
                    spellcheck="false"
                    placeholder=" "
                    class="mt-3"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
                <v-col class="pl-1">
                  <v-text-field
                    label="CNPJ *"
                    v-model="novaArte.cnpj"
                    :disabled="capturaAutomaticaFTP"
                    spellcheck="false"
                    placeholder=" "
                    class="mt-3"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-file-input
                    label="Imagem (Upload p/S3 na AWS) *"
                    spellcheck="false"
                    id="upload"
                    accept="image/png, image/jpeg, image/bmp"
                    v-model="file"
                    @change="mostrarImagem()"
                    ref="fileInput"
                    class="mt-3"
                    append-outer-icon="mdi-camera"
                    prepend-icon=""
                    placeholder=" "
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
                <v-col style="text-align: right">
                  <v-btn
                    :disabled="!novaArte.cnpj"
                    @click="dialogSelecionarProduto = true"
                    class="mt-4 primary"
                    small
                  >
                    <v-icon class="mr-1 ml-n1">
                      mdi-magnify
                    </v-icon>
                    Selecionar Produto
                  </v-btn>
                </v-col>
              </v-row>
              <div class="mt-3" style="width: 100%; color: orangered" v-if="novaArte.produto">
                <b>PRODUTO: </b>{{ novaArte.produto }}
                <br>
                <b>QTDE: </b> {{ novaArte.qtde }}
                <br>
                <b>ID: </b>{{ novaArte.produto_id }}
              </div>
              <img
                :src="file ? imagemTmp : require('@/assets/imagem-indisponivel-2.png')"
                :class="file ? 'fs-img-upload' : 'fs-img-upload-tmp'"
                alt=""
              >
            </v-form>
          </v-card-text>
          <v-divider class="mt-n2 mb-2"/>
          <v-card-actions class="mx-2 pb-4">
            <v-spacer />
            <v-btn
              :disabled="loading"
              @click="uploadArteFinal()"
              color="primary"
              small
            >
              <v-icon class="mr-1">
                mdi-upload
              </v-icon>
              Fazer Upload
            </v-btn>
            <v-btn
              :disabled="loading"
              @click="dialogUpload = false"
              color="error"
              small
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="950px" v-model="dialogSelecionarProduto">
        <v-card>
          <v-card-title>
            Selecione o Produto da Arte
          </v-card-title>
          <v-divider class="ma-0 "/>
          <v-card-text>
            <v-data-table
              :headers="headersProdutosArteUpload"
              :items="produtosArteUpload"
              :items-per-page="5"
              hide-default-footer
              class="elevation-1 mt-5"
            >
              <template v-slot:body="{ items }">
                <tr
                  id="fs-row"
                  v-for="(row, index) in items"
                  :key="index"
                >
                  <td>{{ row.produto_id }}</td>
                  <td>{{ formatarDataHora(row.emissao, 'DD/MM/YYYY') }}</td>
                  <td>{{ row.notafiscal }}</td>
                  <td>{{ row.produto }}</td>
                  <td width="80px">{{ row.prod_qcom }}</td>
                  <td width="50px">
                    <v-btn
                      @click="selecionarProduto(row)"
                      height="20px"
                      class="primary px-2"
                      small
                    >
                      Selecionar
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider class="ma-0 "/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" @click="dialogSelecionarProduto = false" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="400px" v-model="dialogExcel">
        <v-card>
          <v-card-title>
            Seu arquivo está pronto!
          </v-card-title>
          <v-card-text>
            Faça o download clicando no botão abaixo.
          </v-card-text>
          <v-divider class="ma-0 "/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#2A2F50" download="report.csv" :href="linkExcel" @click="dialogExcel = false" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>
              Fazer Download
            </v-btn>
            <v-btn color="warning" @click="dialogExcel = false" dark small>
              <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAmpliarArteUpload" width="700px">
        <v-card class="pl-1 pt-5">
          <v-btn style="position: absolute; right: 0; top: 0" color="error" large icon @click="dialogAmpliarArteUpload = false">
            <v-icon style="font-size: 30px !important">mdi-close-circle</v-icon>
          </v-btn>
          <br>
          <img
            :src="urlArteDialogAmpliar"
            style="width: 690px; max-width: 89vw; border-radius: 5px"
            alt=""
          >
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFiltros" width="450px">
        <v-card>
          <v-btn @click="dialogFiltros = false" style="position: absolute; right: 0; top: 0" icon>
            <v-icon style="font-size: 25px !important">mdi-close</v-icon>
          </v-btn>
          <v-form autocomplete="off">
            <v-card-title>Filtros Específicos</v-card-title>
            <v-divider class="mt-n1 mb-n3"/>
            <v-card-text>
              <v-row class="px-2 pb-1 fs-div-checkbox-filtro" no-gutters>
                <v-col md="12">
                  <div class="mb-4">
                    <label class="fs-label-filtro">Intervalo de Datas</label>
                  </div>
                </v-col>
                <v-col md="5">
                  <v-menu
                    v-model="menuDataInicialFiltro"
                    :close-on-content-click="false"
                    :nudge-top="48"
                    :nudge-right="10"
                    transition="scale-transition"
                    max-width="290"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="mb-n5 mr-1"
                        :value="formatDataInicial"
                        append-outer-icon="mdi-calendar"
                        label="Data Inicial"
                        placeholder=" "
                        @click:clear="dataInicial = null"
                        v-on="on"
                        outlined
                        readonly
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataInicial"
                      @change="menuDataInicialFiltro = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="5">
                  <v-menu
                    v-model="menuDataFinalFiltro"
                    :close-on-content-click="false"
                    :nudge-top="48"
                    :nudge-right="10"
                    transition="scale-transition"
                    max-width="290"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="mb-n5 ml-1"
                        :value="formatDataFinal"
                        append-outer-icon="mdi-calendar"
                        label="Data Final"
                        placeholder=" "
                        @click:clear="dataFinal = null"
                        v-on="on"
                        outlined
                        readonly
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataFinal"
                      @change="menuDataFinalFiltro = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-switch
                        v-model="filtroData"
                        v-on="on"
                        class="mt-0 ml-5"
                        color="#2A2F50"
                        :value="true"
                        hide-details
                      ></v-switch>
                    </template>
                    <span style="font-size: 11px">
                      {{ filtroData ? 'FILTRO POR DATA ATIVADO' : 'FILTRO POR DATA DESATIVADO' }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <div class="fs-div-checkbox-filtro">
                <v-row no-gutters>
                  <v-col>
                    <label class="fs-label-filtro">Status da Arte</label>
                    <v-select
                      class="mr-1 mt-3 mb-2"
                      label="Status"
                      v-model="filtros.status_arte_envio"
                      :items="opcoesFiltroStatus"
                      item-text="text"
                      item-value="value"
                      height="32px"
                      hide-details
                      placeholder=" "
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="filtros = {}" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="warning" small>
                <v-icon class="mr-1">mdi-close</v-icon>
                Resetar Campos
              </v-btn>
              <v-btn @click="atualizarFiltros()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="primary" small>
                <v-icon class="mr-1">mdi-refresh</v-icon>
                Atualizar Filtros
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-card class="mt-2" outlined tile>
        <v-data-table
          height="650px"
          :loading="loading"
          loading-text="Carregando, aguarde..."
          :headers="headers"
          :items="artes.data"
          :items-per-page="9999999"
          hide-default-footer
          hide-action
          v-model="selecionados"
          show-select
          item-key="id"
        >
          <template v-slot:body="{ items }">
            <tr id="fs-artes-row" :class="colorirRow(row)" v-for="row in items" :key="row.id">
              <td>
                <v-checkbox
                  color="#2A2F50"
                  v-model="selecionados"
                  :value="row"
                  style="margin:0px; padding:0px"
                  hide-details
                />
              </td>
              <td>{{ row.id }}</td>
              <td>{{ row.nome_arte }}</td>
              <td>{{ row.arte.razao_social }}</td>
              <td>{{ row.arte.cnpj | formatarCNPJ }}</td>
              <td>{{ row.arte.cliente_id }}</td>
              <!-- <td>{{ String(row.arte.cliente_id).padStart(9, '0') }}</td> -->
              <td>{{ row.created_at }}</td>
              <td>{{ row.updated_at }}</td>
              <td>
                <v-chip
                  v-if="row.status_arte_envio === '0'"
                  color="white"
                  class="fs-chip"
                  small
                >
                  Pendente
                </v-chip>
                <v-chip
                  v-else-if="row.status_arte_envio === '1'"
                  color="error"
                  class="fs-chip"
                  small
                >
                  Enviado p/ Aprovação do Cliente
                </v-chip>
                <v-chip
                  v-else-if="row.status_arte_envio === '2'"
                  color="primary"
                  class="fs-chip"
                  small
                >
                  Aprovado Pelo Cliente
                </v-chip>
                <v-chip
                  v-else-if="row.status_arte_envio === '3'"
                  color="warning"
                  class="fs-chip"
                  small
                >
                  Reprovado Pelo Cliente
                </v-chip>
                <v-chip
                  v-else-if="row.status_arte_envio === '4'"
                  color="black"
                  dark
                  class="fs-chip"
                  small
                >
                  Cancelado Pelo Usuário
                </v-chip>
              </td>
              <td>
                <v-chip
                  v-if="row.url_arte"
                  @click="visualizarArte(row)"
                  color="primary"
                  class="fs-chip"
                  small
                >
                  Visualizar Arte
                </v-chip>
                <v-chip
                  v-else
                  color="warning"
                  dark
                  class="fs-chip"
                  small
                >
                  Arte Não Disponível
                </v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-row
          class="pl-4 pr-6 py-3"
          style="background-color: white"
          no-gutters
        >
          <v-col cols="12">
            <v-row align="center" justify="space-between">
              <v-card class="ml-3" flat>
                <v-btn-toggle v-model="limit" mandatory group dense>
                  <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                  <v-btn :value="30" class="fs-btn-limit">30</v-btn>
                  <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                  <v-btn :value="100" class="fs-btn-limit">100</v-btn>
                  <div
                    v-if="artes.data"
                    style="background-color: #EEEEEE; padding: 10px; margin: 5px; color: gray; font-size: 11px; letter-spacing: 1px"
                  >{{ artes.total }} REGISTROS</div>
                </v-btn-toggle>
              </v-card>
              <v-card flat>
                <v-pagination
                  color="#2A2F50"
                  v-model="page"
                  :length="artes.lastPage"
                  circle
                  total-visible="8"
                ></v-pagination>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <v-overlay :value="loading" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import * as api from '@/api/crud' // eslint-disable-line
import { uploadArteFinal, apiExcelArtesPersonalizadas, apiExcluirArteS3, apiExcelArtesEnvios } from '@/api/controledeartes' // eslint-disable-line

import moment from 'moment'

export default {
  filters: {
    formatarCNPJ (cnpj) {
      if (cnpj === null) {
        return ''
      }
      let mascara = cnpj.replace(/\D/g, '')
      if (mascara.length <= 14) {
        mascara = mascara.replace(/^(\d{2})(\d)/, '$1.$2')
        mascara = mascara.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        mascara = mascara.replace(/\.(\d{3})(\d)/, '.$1/$2')
        mascara = mascara.replace(/(\d{4})(\d)/, '$1-$2')
      }
      return mascara
    }
  },
  data () {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'NOME ARTE', value: 'nome_arte' },
        { text: 'RAZÃO SOCIAL', value: 'arte.razao_social' },
        { text: 'CNPJ', value: 'arte.cnpj' },
        { text: 'COD CLIENTE', value: 'arte.cliente_id' },
        { text: 'DT/HR CRIAÇÃO', value: 'created_at' },
        { text: 'ULT. INTERAÇÃO', value: 'updated_at' },
        { text: 'STATUS', value: 'status_arte_envio' },
        { text: '', value: 'url_arte', sortable: false }
      ],
      headersProdutosArteUpload: [
        { text: 'ID', value: 'produto_id' },
        { text: 'DATA', value: 'emissao' },
        { text: 'NFE', value: 'notafiscal' },
        { text: 'PRODUTO', value: 'produto' },
        { text: 'QTDE', value: 'prod_qcom' },
        { text: ' ' }
      ],
      opcoesFiltroStatus: [
        { text: 'Pendente', value: '0' },
        { text: 'Enviado P/ Aprovação do Cliente', value: '1' },
        { text: 'Aprovado Pelo Cliente', value: '2' },
        { text: 'Reprovado Pelo Cliente', value: '3' },
        { text: 'Cancelado Pelo Usuário', value: '4' }
      ],
      dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
      dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
      menuDataFinal: false,
      menuDataFinalFiltro: false,
      menuDataInicial: false,
      menuDataInicialFiltro: false,
      capturaAutomaticaFTP: true,
      filtros: {},
      dialogDetalhes: false,
      filtroComposto: [],
      filtroData: false,
      selecionados: [],
      dialog: false,
      dialogFiltros: false,
      dialogUpload: false,
      dialogExcel: false,
      dialogSelecionarProduto: false,
      linkExcel: null,
      textoPesquisa: '',
      urlArteDialogAmpliar: '',
      dialogAmpliarArteUpload: false,
      imagemTmp: require('@/assets/imagem-indisponivel-2.png'),
      file: null,
      produtosArteUpload: [],
      artes: [],
      novaArte: {},
      novoEnvio: {},
      loading: true,
      limit: 20,
      page: 1
    }
  },
  watch: {
    page: function () {
      this.filtrar()
    },
    limit: function () {
      this.page = 1
      this.filtrar()
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser']),
    ...mapState({
      confirm: state => state.global.confirm
    }),
    formatDataInicial () {
      return this.dataInicial ? moment(this.dataInicial).format('DD/MM/YYYY') : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).format('DD/MM/YYYY') : ''
    }
  },
  mounted () {
    this.filtrar()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    ...mapActions({
    }),
    limparFormUpload () {
      this.novaArte = {}
      this.novoEnvio = {}
      this.file = null
      this.imagemTmp = require('@/assets/imagem-indisponivel-2.png')
    },
    buscarDadosClienteID () {
      if (this.novaArte.cliente_id && this.novaArte.cliente_id.length) {
        this.loading = true
        setTimeout(() => {
          // console.log(this.novaArte.cliente_id)
          this.loading = false
        }, 2000)
      }
    },
    selecionarProduto (p) {
      this.novaArte.produto_id = p.produto_id
      this.novaArte.produto = p.produto
      this.novaArte.qtde = p.prod_qcom
      this.dialogSelecionarProduto = false
    },
    visualizarArte (item) {
      this.dialogAmpliarArteUpload = true
      this.urlArteDialogAmpliar = item.url_arte
    },
    formatUppercase () {
      if (this.novoEnvio.nome_arte) this.novoEnvio.nome_arte = this.novoEnvio.nome_arte.toUpperCase()
      if (this.novaArte.razao_social) this.novaArte.razao_social = this.novaArte.razao_social.toUpperCase()
    },
    selectRow (value) {
      const aux = this.selecionados
      if (aux.find(item => { return item === value })) {
        const index = aux.indexOf(value)
        aux.splice(index, 1)
      } else {
        aux.push(value)
      }
    },
    async exportarExcel () {
      this.loading = true
      setTimeout(async () => {
        this.montarFiltroComposto()
        const csvString = await apiExcelArtesEnvios(this.querySerialize('filtro', this.filtroComposto))
        const universalBOM = '\uFEFF'
        this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
        this.loading = false
        this.dialogExcel = true
        this.downloadExcel = true
      }, 700)
    },
    colorirRow (item) {
      if (this.selecionados.find(row => { return row === item })) return 'fs-row-selected'
      return 'tr-normal'
    },
    limparFiltros () {
      this.page = 1
      this.filtros = {}
      this.filtroData = false
      this.filtrar()
    },
    filtrarStatus () {
      this.filtrar()
    },
    async pesquisar () {
      this.filtros = {}
      this.loading = true
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      const pesquisa = []
      if (this.textoPesquisa.length) pesquisa.push({ field: 'todos', value: this.textoPesquisa })
      this.artes = await api.list2('/crm/controleartesenviofiltro', { tipo: 'pesquisa', query: this.serializePesquisa('pesquisa', pesquisa) }, paginate)
      this.selecionados = []
      this.loading = false
    },
    atualizarFiltros () {
      this.page = 1
      this.dialogFiltros = false
      this.filtrar()
    },
    async filtrar () {
      this.loading = true
      this.montarFiltroComposto()
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      const obj = {
        tipo: 'filtro',
        query: this.querySerialize('filtro', this.filtroComposto)
      }
      this.artes = await api.list2('/crm/controleartesenviofiltro', obj, paginate)
      this.selecionados = []
      this.loading = false
    },
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    formatarMoeda (number, digits) {
      number = parseFloat(number).toFixed(digits)
      number = number.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(number)) { number = number.replace(pattern, '$1,$2') }
      return 'R$ ' + number
    },
    async montarFiltroComposto () {
      this.filtroComposto = []
      const keys = Object.keys(this.filtros)
      for (let i = 0; i < keys.length; i++) {
        if (!this.filtros[keys[i]] || this.filtros[keys[i]] === '') { continue }
        if (typeof this.filtros[keys[i]] === 'object' && !this.filtros[keys[i]].length) { continue }
        if (this.filtros[keys[i]]) {
          const type = this.filtros[keys[i]].length ? typeof this.filtros[keys[i]][0] : typeof this.filtros[keys[i]]
          this.filtroComposto.push({ field: keys[i], value: this.filtros[keys[i]], type })
        }
      }
      if (this.filtroData) {
        this.filtroComposto.push({ field: 'dataInicial', value: this.dataInicial + ' 00:00:00' })
        this.filtroComposto.push({ field: 'dataFinal', value: this.dataFinal + ' 23:59:59' })
      }
    },
    async buscarDadosPeloCliente () {
      this.loading = true
      if (this.novaArte.cliente_id) {
        const clienteID = this.novaArte.cliente_id
        try {
          const res = await api.get('/crm/controleartes/buscarultimositens', null, clienteID)
          if (res.cliente.length) {
            this.produtosArteUpload = res.produtos
            this.novaArte.cnpj = res.cliente[0].cnpj
            this.novaArte.razao_social = res.cliente[0].nome
            this.novaArte.cliente_id = clienteID
            if (res.produtos.length === 1) this.selecionarProduto(res.produtos[0])
          } else {
            this.setSnackbar({ msg: `Nenhum cliente foi encontrado com o ID: ${clienteID}`, color: 'red' })
          }
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
        if (this.file) this.imagemTmp = URL.createObjectURL(this.file)
      } else {
        this.setSnackbar({ msg: 'Digite o código do cliente.', color: 'red' })
      }
      this.loading = false
    },
    async mostrarImagem () {
      this.loading = true
      if (this.capturaAutomaticaFTP && this.file) {
        const arr = this.file.name.split('-')
        const clienteID = parseInt(arr[1], 10)
        try {
          const res = await api.get('/crm/controleartes/buscarultimositens', null, clienteID)
          // console.log(res)
          if (res.cliente.length) {
            this.produtosArteUpload = res.produtos
            this.novaArte.cnpj = res.cliente[0].cnpj
            this.novaArte.razao_social = res.cliente[0].nome
            this.novaArte.cliente_id = clienteID
            if (res.produtos.length === 1) this.selecionarProduto(res.produtos[0])
          } else {
            this.setSnackbar({ msg: `Nenhum cliente foi encontrado com o ID: ${clienteID}`, color: 'red' })
          }
        } catch (error) {
          this.setSnackbar({ msg: 'Nenhum cliente foi encontrado. Verifique se o nome da imagem está no padrão.', color: 'red' })
        }
      }
      if (this.file) this.imagemTmp = URL.createObjectURL(this.file)
      this.loading = false
    },
    async excluirArteFinal () {
      if (await this.confirm.open('Excluir Arte do S3', 'Tem certeza que deseja continuar?', { color: 'red' })) {
        this.loading = true
        const obj = this.selecionados.map(row => {
          return { id: row.id, url_arte: row.url_arte }
        })
        try {
          // console.log(obj)
          const res = await apiExcluirArteS3(obj)
          if (res) {
            this.setSnackbar({ msg: 'Arte(s) excluída(s) com Sucesso!', color: 'success', timeout: 4000 })
            this.filtrar()
          }
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      }
      this.loading = false
    },
    async uploadArteFinal () {
      this.loading = true
      if (this.file && this.novoEnvio.nome_arte && this.novaArte.razao_social && this.novaArte.cliente_id) {
        if (!this.novaArte.produto_id) {
          this.setSnackbar({ msg: 'Selecione o PRODUTO referente à arte carregada!', color: 'red', timeout: 4000 })
        } else {
          const formData = new FormData()
          const obj = {
            hello: 'world'
          }
          formData.append('file', this.file, this.novoEnvio.nome_arte)
          formData.append('data', obj)
          try {
            this.novaArte.tipo = '2'
            delete this.novaArte.qtde
            const arte = await api.add('/crm/controleartes', null, this.novaArte)
            await uploadArteFinal(formData, arte.id)
            this.filtrar()
            this.dialogUpload = false
            this.file = null
            this.imagemTmp = require('@/assets/imagem-indisponivel-2.png')
            this.novoEnvio = {}
            this.novaArte = {}
            this.setSnackbar({ msg: 'Upload Realizado com Sucesso!', color: 'success', timeout: 4000 })
          } catch (e) {
            this.setSnackbar({ msg: 'Ocorreu um erro ao fazer upload!', color: 'red', timeout: 4000 })
          }
        }
      } else {
        this.setSnackbar({ msg: 'Informe os campos corretamente!', color: 'red' })
      }
      this.loading = false
    },
    querySerialize (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) query = query + nome
        query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtro[i]))
        if (i < filtro.length - 1) query = query + `&${nome}`
      }
      query = query.replace(/%2C/g, ',')
      return query
    },
    serializePesquisa (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtro[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtro[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style scoped>
#fs-row:hover {
  background-color: rgba(236, 236, 236, 0.603);
}
#fs-artes-row:hover {
  background-color: rgba(236, 236, 236, 0.603);
}
.fs-row-selected {
  background-color: rgb(255, 239, 239) !important;
}
.fs-btns-top:active,
.fs-btns-top:focus {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-searchfield .v-input__icon--append .v-icon {
  margin-top: -6px;
  font-size: 23px !important;
}
.fs-searchfield .v-input__icon--append .v-icon:hover {
  color: black;
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-topbar-crud {
  text-align: right;
  margin-top: -3px;
}
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}
.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-card-topbar {
  height: 62px;
  border-bottom-right-radius: 0px;
}
.fs-checkbox-filtros {
  padding-top: 0px !important;
  margin-left: -5px !important;
  margin-top: -5px !important;
  height: 30px !important;
}
.fs-div-checkbox-filtro {
  background-color: #F8F8F8;
  border: 1px solid #CCC;
  border-radius: 4px;
  padding: 5px 10px 2px 10px;
  margin-top: 10px;
  text-align: center;
  border-radius: 4px;
}
.fs-img-upload {
  margin-top: 12px;
  width: 553px;
  max-width: 553px;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 4px;
}
.fs-img-upload-tmp {
  margin-top: 12px;
  width: 200px;
  max-width: 200px;
  height: 190px;
  max-height: 190px;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 4px;
}
</style>
